export default __webpack_public_path__ + "static/media/rack3.53d954ce.jpg";